import { FC } from 'react';
import Link from 'next/link';
import cn from 'classnames';
import { useGetGlobalSettings } from 'hooks';
import { Menu } from './Menu';
import LandrMini from '../../public/icons/landr-mini.svg';
import styles from './Header.module.scss';
import { getHost } from '../../utils/host';

export type HeaderProps = {
  color?: 'black' | 'white';
};

export const Header: FC<HeaderProps> = ({ color = 'black' }) => {
  const settings = useGetGlobalSettings();

  const siteTitle = settings?.siteTitle || 'LANDR BLOG';

  const LandrLogo = () => {
    return (
      <Link href={getHost() || `https://${settings?.siteLink}`} passHref>
        <div className={styles.titleWrapper}>
          <LandrMini className={styles.logo} />
          <p className={styles.title}>{siteTitle}</p>
        </div>
      </Link>
    );
  };

  return (
    <header
      className={cn(styles.root, {
        [styles[`font-color-${color}`]]: color,
      })}
    >
      <LandrLogo />
      <Menu />
    </header>
  );
};
